module.exports = __webpack_public_path__ + "static/media/icon_nav_on_kpi.a8cd2244.svg";